import React from "react";
import { useAppContext } from "../../AppProvider";
import { useIndexUsersContext } from "./providers/Index.tsx";
import ButtonUtility from "../../Components/Buttons/Utility.tsx";
import ButtonConfirm from "../../Components/Buttons/Confirm.tsx";
import { faLoader } from "../../utilities/fontawesomeIcons.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSendInvitationMailContext } from "./providers/SendInvitationMail.tsx";

const SendInvitationMail = () => {
  const { sendInvitationMail, loader, callback } =
    useSendInvitationMailContext();
  const indexUsersContext = useIndexUsersContext();
  const { dictionary } = useAppContext();

  return (
    <React.Fragment>
      {loader ? (
        <div className="text-center mt-2">
          <FontAwesomeIcon icon={faLoader} spin size="2x" />
        </div>
      ) : (
        <React.Fragment>
          <h3 className="text-center">
            {indexUsersContext?.modalConfig?.title}
          </h3>
          <p className="text-center">
            {dictionary.users.email_sending_confirmation_message}
          </p>

          <div className="d-flex mt-3">
            <ButtonUtility
              className="w-50 me-2"
              onClick={() => {
                if (callback) {
                  callback();
                }
              }}
            >
              {dictionary.actions.cancel}
            </ButtonUtility>
            <ButtonConfirm
              className="w-50"
              onClick={() => sendInvitationMail()}
              disabled={loader}
              loading={loader}
            >
              {dictionary.actions.send}
            </ButtonConfirm>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default SendInvitationMail;
